export class Telephone {

    id: string;
    identites_id: string;
    type: string;
    libelle: string;
    first: string;
    ref_metier: string;
    readonly: string;

    constructor(type: string, data?: any) {
        if (!data) {
            data = [];
        }

        this.id             = data['id'] ? data['id'] : null;
        this.identites_id   = data['identites_id'] ? data['identites_id'] : null;
        this.type           = type;
        this.libelle        = data['libelle'] ? data['libelle'] : null;
        this.first          = data['first'] ? data['first'] : '';
        this.ref_metier     = data['ref_metier'] ? data['ref_metier'] : null;
        this.readonly       = data['readonly'] ? data['readonly'] : '0';
    }

}
